import { useEffect } from 'react';

import { useBarcode } from '~/modules/devices/hooks/useBarcode';
import { newRelic } from '~/utils/newRelic/newRelic';

import { SCAN_EVENT_QUEUE } from '../constants/scanEventQueue.const';
import { createScanBarcodeContent } from '../utils/createScanBarcodeContent.util';
import { createScanContext } from '../utils/createScanContext.util';
import { createScanEventProcessor } from '../utils/createScanEventProcessor.util';
import { createScanActionHandler } from '../utils/scanActionHandler.util';

/**
 * Mounts the sole consumer of the scan event queue.
 */
export const useScanEventProcessor = () => {
  const { resolveBarcode } = useBarcode();

  useEffect(() => {
    const scanActionHandler = createScanActionHandler();

    const processor = createScanEventProcessor({
      getScanContext: (source) =>
        createScanContext({
          ...source,
          getBarcodeContent: (barcodeSource) =>
            createScanBarcodeContent({ ...barcodeSource, resolveBarcode }),
        }),
      handleScanEvent: scanActionHandler.handle,
      queue: SCAN_EVENT_QUEUE,
    });

    return SCAN_EVENT_QUEUE.subscribe(() => {
      processor
        .process()
        .catch((error) => newRelic.noticeError('Failed to drain the scan event queue', { error }));
    });
  }, [resolveBarcode]);
};
